export default "__VITE_ASSET__B_$c42Xi__"